// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import axios from "axios"; // Assurez-vous d'importer axios


const firebaseConfig = {
  apiKey: "AIzaSyAPOFo63-C60VgjxGTKZVdqcS7kTJ78j8A",
  authDomain: "lpadev.firebaseapp.com",
  projectId: "lpadev",
  storageBucket: "lpadev.firebasestorage.app",
  messagingSenderId: "813489438516",
  appId: "1:813489438516:web:03b3c24d683adfdbc76f61",
  measurementId: "G-D78HKCX5P8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);

// export const generateToken = async () => {
//   const permission = await Notification.requestPermission();
//   console.log("Permission demandée:", permission); // Ajoutez cette ligne

//   if (permission === "granted") {
//     // Demander le token de notification
//     console.log("Permission accordée pour les notifications");
//     const currentToken = await getToken(messaging, {
//       vapidKey:
//         "BBhdyTYwY0KZk_7letQOknbGtB1kRoxGIEknNBVPypnoqUH-GPPP18djQkPD2DnRtS6KBM-nuu_RxX67dIrfB7E", // Assurez-vous de remplacer par votre propre VAPID Key
//     });
//     console.log(currentToken);
//   } else {
//     console.log("Permission refusée pour les notifications");
//   }
// };

export const generateToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    console.log(permission);

    if (permission === "granted") {
      console.log("Permission accordée pour les notifications");
      const currentToken = await getToken(messaging, {
        vapidKey:
          "BIaGTk2wEpWRjpAHqtAxLnshrwY9ovAeSbJlaZe7sioESA2CEnT8a97ITFcoX5xwq9wruYMes4F4ZPliD0Uv80A", // Assurez-vous de remplacer par votre propre VAPID Key // Remplacez par la bonne VAPID Key
          // 
      });
      if (currentToken) {
        // console.log("Token de notification:", currentToken);

        await sendTokenToBackend(currentToken);
      } else {
        console.log("Aucun token disponible.");
      }
    } else {
      console.log("Permission refusée pour les notifications");
    }
  } catch (error) {
    console.error("Erreur lors de la génération du token:", error);
  }
};

// Fonction pour envoyer le token au backend
// const sendTokenToBackend = async (token) => {
//   try {
//     const response = await axios.post('https://lpa.softsolutionsdev.com/api/save-token', { token });
//     console.log("Token envoyé au backend avec succès", response.data);
//   } catch (error) {
//     console.error("Erreur lors de l'envoi du token au backend", error);
//   }
// };

const sendTokenToBackend = async (token) => {
  try {
    const authToken = localStorage.getItem('token');  // ou un autre stockage sécurisé
    const response = await axios.post(
      'https://lpa.softsolutionsdev.com/api/save-token', 
      { token },
      { headers: { Authorization: `Bearer ${authToken}` } }  // Ajout du token d'authentification
    );
    console.log(response.data);
  } catch (error) {
    console.error("Erreur lors de l'envoi du token au backend", error);
  }
};

